import {Component, OnInit} from '@angular/core';
import {HistoricalValueControllerService, HistoricalValuePresentationDTO, ProductTypeDTO} from '../../api';
import {HistoricalValuesService} from './services/historical-values.service';
import {HttpErrorResponse} from '@angular/common/http';
import {formatDate} from '@angular/common';

@Component({
  selector: 'app-historical-values',
  templateUrl: './historical-values.component.html',
  styleUrls: ['./historical-values.component.scss']
})
export class HistoricalValuesComponent implements OnInit {

  public historicalValues: Array<HistoricalValuePresentationDTO>;
  public filtersData;

  constructor(private historicalValueControllerService: HistoricalValueControllerService,
              private historicalValuesService: HistoricalValuesService) {
  }

  ngOnInit(): void {
    this.registerProductTypeChangeEvent();
  }

  private registerProductTypeChangeEvent() {
    this.historicalValuesService.selectedProductTypeSource$.subscribe((searchInfo: any) => {
      this.getPriceHistoryForProductTypeAndBuildDataForViewRepresentation(searchInfo.productType, searchInfo.startDate, searchInfo.endDate);
    });
  }

  private getPriceHistoryForProductTypeAndBuildDataForViewRepresentation(productTypeDTO: ProductTypeDTO, startDate: Date, endDate: Date) {
    const me = this;
    this.historicalValues = [];
    if (productTypeDTO.id && startDate && endDate) {
      me.historicalValueControllerService.findHistoricalValuesForPresentationForProductTypeIdBetweenDatesUsingGET(
        productTypeDTO.id, formatDate(startDate, 'YYYY-MM-DD', 'de_DE'), formatDate(endDate, 'YYYY-MM-DD', 'de_DE'))
        .subscribe((historicalValues: Array<HistoricalValuePresentationDTO>) => {
          this.historicalValues = historicalValues;
        }, (error: HttpErrorResponse) => {
          console.log(error);
        });
    }
  }

}
